import numeral from 'numeral';
import { YNOptions } from '../../constants';

export const booleanFlagParser = ({ trueValue, falseValue }) => ({ newValue, oldValue }) => {
  if (newValue === trueValue || newValue === falseValue) {
    return newValue;
  }
  return oldValue;
};

export const intParser = ({ newValue, oldValue }) => {
  const value = numeral(newValue).value();
  if (Number.isInteger(value)) {
    return value;
  }
  return oldValue;
};
export const nullableIntParser = ({ newValue, oldValue }) => (newValue !== '') ? intParser({ newValue, oldValue }) : null;

export const floatParser = ({ newValue, oldValue }) => {
  const value = numeral(newValue).value();
  if (value === null || Number.isNaN(value)) {
    return oldValue;
  }
  return value;
};

export const nullableFloatParser = ({ newValue, oldValue }) => {
  if (newValue === null || typeof newValue === 'undefined' || newValue === '') {
    return null;
  }
  const value = numeral(newValue).value();
  if (value === null || Number.isNaN(value)) {
    return oldValue;
  }
  return value;
};

export const nullableStringParser = ({ newValue }) => (newValue !== '') ? newValue : null;

export const stringArrayParser = ({ newValue }) => newValue ? newValue.split(',').map(val => val.trim()) : [];

export const YNFlagParser = booleanFlagParser({
  trueValue: YNOptions.Y,
  falseValue: YNOptions.N,
});

export const allowOnlyParser = (allowedValues, { parseEmptyStringToNull } = {}) => ({ newValue, oldValue }) => {
  if (parseEmptyStringToNull && (newValue === '' || newValue === null)) {
    return null;
  }
  if (allowedValues.includes(newValue)) {
    return newValue;
  }
  return oldValue;
};
export const booleanParser = ({ newValue }) => newValue === true || newValue === 'true';
